import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FiHome, FiInfo, FiGrid, FiBookOpen, FiBriefcase, FiMail } from "react-icons/fi";
import logo from '../../assets/gh2.png'

function Drawer() {
    const location = useLocation();
    function handleUlClick(event) {
        if (event.target.closest('a')) {
            const drawerToggle = document.getElementById("nav-drawer");
            if (drawerToggle) drawerToggle.click();
        }
    }
    const getLinkClass = (path) => {
        const isActive = location.pathname === path;
        const baseClass = "flex items-center gap-3 px-4 py-3 rounded transition-colors duration-200 text-sm font-medium";
        return isActive
            ? `${baseClass} bg-primary/10 text-primary font-bold`
            : `${baseClass} text-zinc-400 hover:bg-zinc-800 hover:text-primary`;
    };

    return (
        <div className="drawer-side z-[100]" >
            <label htmlFor="nav-drawer" className="drawer-overlay"></label>

            <div className="p-4 w-72 bg-neutral h-full border-r border-zinc-600" data-theme="guardhartDark">

                <div className="py-6 mb-4 border-b border-zinc-600">
                    <Link to="/" className="text-2xl font-bold tracking-tighter text-base-content hover:text-primary transition-colors block text-center">
                        <img src={logo} alt="Guardhart" className="h-36 mx-auto rounded" />
                    </Link>
                </div>

                <ul onClick={handleUlClick} className="menu p-0 text-white">
                    <li>
                        <Link to="/" className={getLinkClass('/')}>
                            <FiHome className="h-5 w-5" /> Home
                        </Link>
                    </li>
                    <li>
                        <Link to="/about" className={getLinkClass('/about')}>
                            <FiInfo className="h-5 w-5" /> About
                        </Link>
                    </li>
                    <li>
                        <Link to="/services" className={getLinkClass('/services')}>
                            <FiGrid className="h-5 w-5" /> Services
                        </Link>
                    </li>
                    <li>
                        <Link to="/blog" className={getLinkClass('/blog')}>
                            <FiBookOpen className="h-5 w-5" /> Blog
                        </Link>
                    </li>
                    <li>
                        <Link to="/careers" className={getLinkClass('/careers')}>
                            <FiBriefcase className="h-5 w-5" /> Careers
                        </Link>
                    </li>
                    <li>
                        <Link to="/contact" className={getLinkClass('/contact')}>
                            <FiMail className="h-5 w-5" /> Contact
                        </Link>
                    </li>
                </ul>

                {/* Bottom CTA */}
                <div className="mt-8 pt-6 border-t border-zinc-600">
                    <Link
                        to="/contact"
                        className="block w-full bg-primary text-primary-content px-4 py-3 text-xs font-bold uppercase tracking-widest text-center rounded hover:brightness-110 transition-all"
                    >
                        Get a Quote
                    </Link>
                    <p className="text-xs text-zinc-500 text-center mt-4">
                        PSRA Licensed | Fully Ensured
                    </p>
                </div>
            </div>
        </div>
    );
}

export default Drawer;